import { MockNote } from '@/components/foundations';
import { AppShell, PageHeader, PageTitle } from '@/components/layout';
import { Button } from '@/components/forms';
import { Badge, Panel, SummaryList } from '@/components/data';
import { RulesTable } from './components';
import { CATEGORIES, RULES, brl } from '@/mocks/financas';

/** Categorias e regras de categorização — mock. */
export function FinCategoriasPage() {
  return (
    <AppShell>
      <main className="content">
        <PageHeader subtitle="Organize como seus gastos são classificados." period="Outubro 2026" />
        <PageTitle variant="page" title="Categorias e regras" style={{ marginBottom: 16, alignItems: 'center' }} actions={<Button icon="tag">Nova regra</Button>} />
        <section className="dash-grid" style={{ gridTemplateColumns: 'minmax(290px,1fr) minmax(0,1.9fr)' }}>
          <Panel title="Categorias" action={<a className="link" style={{ color: 'var(--gold-d)', fontWeight: 500 }} href="#">+ Nova</a>}>
            <SummaryList
              items={CATEGORIES.map((c) => ({ key: c.id, labelStyle: { display: 'inline-flex', alignItems: 'center', gap: 10 }, label: <><i style={{ width: 10, height: 10, borderRadius: '50%', background: c.color }} />{c.name}</>, value: brl(c.total) }))}
              total={{ label: 'Sem categoria', value: <Badge tone="err">3 itens</Badge>, bold: false }}
            />
          </Panel>
          <Panel variant="recent" title="Regras · ordem de prioridade" action={<span style={{ color: 'var(--muted)', fontSize: 13.5 }}>Manual &gt; Regras &gt; Categoria Pluggy &gt; Sem categoria</span>}>
            <RulesTable rules={RULES} />
            <div style={{ padding: '16px 8px 6px' }}><Button variant="outline-gold" icon="refresh">Reaplicar regras (não altera manuais)</Button></div>
          </Panel>
        </section>
        <MockNote />
      </main>
    </AppShell>
  );
}
